import { connect } from 'react-redux'
import Vote from './Vote'
import { listenForPoll } from '../../redux/actions/poll'
import { getVote, castVote } from '../../redux/actions/vote'

const mapStateToProps = ({ polls, vote }, { params }) => ({
	poll: polls[params.pollId],
	vote,
})

const mapDispatchToProps = (dispatch, { params }) => ({
	load() {
		dispatch(listenForPoll(params.pollId))
		dispatch(getVote(params.pollId))
	},
	submit(option) {
		dispatch(castVote(params.pollId, option))
	},
})

const Container = connect(
  mapStateToProps,
  mapDispatchToProps,
)(Vote)

export default Container



// WEBPACK FOOTER //
// ./src/components/vote/Container.jsx